import { ApiNhgResponse } from '../../../../../@types';
import { API } from '../../../../../services';

const fetchNhg = async (): Promise<ApiNhgResponse> => {
  return API.get<ApiNhgResponse>('nhg');
};

export { fetchNhg };
